import { SUBSCRIPTION_ENTRY } from '@config'

export const cleanDomainUrl = (href: string) =>
  String(href).replace(/^(http(s)?:\/\/(www.)?fortuneo.fr)/i, '')

export const cleanUrl = (href: string) =>
  cleanDomainUrl(href)
    // TODO: we should create in contentful as much cta as SUBSCRIPTION_ENTRY and reference it from other contents (link entry)
    // TODO: PBU fix, editorial team should fix all subscrption links in contentful and inbenta
    .replace(
      /^\/compte-bancaire\/ouvrir-un-compte\/type-compte-courant/,
      SUBSCRIPTION_ENTRY.COMPTE_BANCAIRE
    )
    .replace(
      /^\/compte-bancaire\/ouvrir-un-compte/,
      SUBSCRIPTION_ENTRY.COMPTE_BANCAIRE
    )
